// temporary workaround
// @ts-nocheck
import * as React from 'react';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { Subtitle3 } from '@estee/elc-typography';
import { Emphasis, ContentSpacing } from '@estee/elc-base-theme';
import { SecondaryTextTheme } from '../../../theme/default-theme';
import { MPP_PRODUCT_DETAILS } from '../../constants/DataTestIdAttributes';

export interface ICTALink {
    label: string;
    productUrl?: string;
    onCTALinkClick(): void;
}

const StyledProductDetailsLink = styled.a`
    display: block;
    text-transform: uppercase;
    text-decoration: underline;
    cursor: pointer;
    margin-top: ${ContentSpacing.space20};
    overflow-x: hidden;
    ${SecondaryTextTheme};
`;

export const CTALink = observer(function CTALink(props: ICTALink) {
    const CTALinkClassNames = classnames('elc-cta-link', 'js-cta-link');

    const handleClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        event.preventDefault();
        props.onCTALinkClick();
    };

    return (
        <StyledProductDetailsLink
            href={props.productUrl}
            title={props.label}
            onClick={handleClick}
            className={CTALinkClassNames}
        >
            <Subtitle3 data-test-id={MPP_PRODUCT_DETAILS} emphasis={Emphasis.medium}>
                {props.label}
            </Subtitle3>
        </StyledProductDetailsLink>
    );
});
